// Legend Preact component for displaying marker type colors

import { Signal } from '@preact/signals';
import type { ColorManager } from '../../utils/colors';
import { Panel } from './Panel';
import { panelBody } from './panel';
import { LegendItem } from './legend';

interface LegendProps {
  types: Signal<Set<string>>;
  colorManager: ColorManager;
  onColorChange?: (type: string, color: string) => void;
}

/**
 * Legend component for type color display and editing
 */
export function Legend({ types, colorManager, onColorChange }: LegendProps) {
  const typeArray = Array.from(types.value);

  if (typeArray.length === 0) {
    return null;
  }

  const handleColorChange = (type: string, newColor: string) => {
    colorManager.setColor(type, newColor);
    onColorChange?.(type, newColor);
  };

  return (
    <Panel id="type-legend" title="Légende">
      <div className={panelBody}>
        {typeArray.map((type) => (
          <LegendItem
            key={type}
            type={type}
            color={colorManager.getColor(type)}
            onColorChange={(newColor) => handleColorChange(type, newColor)}
          />
        ))}
      </div>
    </Panel>
  );
}
